/**
 * Shape-matching placeholder for the Social feed.
 * Mirrors the real layout (full-bleed player on phones, player plus side panel
 * on desktop) so nothing jumps when the first video arrives.
 */
const Shimmer = ({ className = "" }: { className?: string }) => (
  <div className={`animate-pulse rounded bg-white/10 ${className}`} />
);

export const SocialFeedSkeleton = () => (
  <div
    aria-busy="true"
    aria-label="Loading videos"
    className="relative flex h-[calc(100dvh-4rem)] w-full flex-col overflow-hidden bg-black lg:flex-row"
  >
    <div className="relative flex min-h-0 flex-1 items-center justify-center bg-black lg:p-4">
      <div className="relative h-full w-full overflow-hidden bg-white/[0.07] lg:h-full lg:w-auto lg:rounded-xl lg:aspect-[9/16]">
        <div className="absolute inset-0 animate-pulse bg-gradient-to-b from-white/[0.14] via-white/[0.06] to-white/[0.14]" />
        <Shimmer className="absolute left-3 top-3 h-6 w-20" />
        <div className="absolute bottom-6 left-4 right-20 space-y-3">
          <Shimmer className="h-4 w-1/3" />
          <Shimmer className="h-3 w-3/4" />
          <Shimmer className="h-3 w-1/2" />
        </div>
        <div className="absolute bottom-6 right-4 space-y-4">
          <Shimmer className="h-11 w-11 rounded-full" />
          <Shimmer className="h-11 w-11 rounded-full" />
          <Shimmer className="h-11 w-11 rounded-full" />
        </div>
      </div>
    </div>

    <aside className="hidden w-[360px] shrink-0 flex-col gap-4 border-l border-white/10 p-5 lg:flex">
      <div className="flex items-center gap-3">
        <Shimmer className="h-10 w-10 rounded-full" />
        <div className="flex-1 space-y-2">
          <Shimmer className="h-3 w-1/2" />
          <Shimmer className="h-3 w-1/3" />
        </div>
      </div>
      <Shimmer className="h-3 w-full" />
      <Shimmer className="h-3 w-5/6" />
      <Shimmer className="h-3 w-2/3" />
      <Shimmer className="mt-4 h-24 w-full" />
    </aside>
  </div>
);

export default SocialFeedSkeleton;
